import { Autocomplete } from '@fullscreendigital/carrefour-dex-fe'
import AddActionIcon from 'icons/AddActionIcon'
import CategoriesIcon from 'icons/iam/CategoriesIcon'
import * as Yup from 'yup'
import { phoneRegExp, statusOptions } from '../helpers'
import { AddShoppingCart, Assignment, BusinessOutlined } from '@mui/icons-material'
import { URLS } from 'components/iam/constants'

export const toolbarActions = ({ canCreate, navigate, openModal }) => {
  const toolbar = [
    {
      label: 'Managers',
      icon: <CategoriesIcon width={18} strokeColor={'#0970E6'} />,
      onClick: () => navigate('/iam/externalPartners/managers')
    },
    {
      label: 'Delegates',
      icon: <CategoriesIcon width={18} strokeColor={'#0970E6'} />,
      onClick: () => navigate('/iam/externalPartners/delegates')
    },
    {
      label: 'Assignments',
      icon: <Assignment width={18} style={{ color: '#0970E6' }} />,
      onClick: () => navigate(URLS.IAM_ASSIGNMENTS)
    },
    {
      label: 'Legal entities',
      icon: <BusinessOutlined width={18} style={{ color: '#0970E6' }} />,
      onClick: () => navigate(URLS.IAM_LEGAL_ENTITIES)
    },
    {
      label: 'Stores',
      icon: <AddShoppingCart width={18} style={{ color: '#0970E6' }} />,
      onClick: () => navigate(URLS.IAM_STORES)
    }
  ]
  const createButton = {
    label: 'Add partner',
    icon: <AddActionIcon />,
    onClick: () => openModal()
  }
  if (canCreate) {
    toolbar.push(createButton)
  }
  return toolbar
}

export const getActiveAssignment = (assignments, onlyActive = false) => {
  const active = assignments
    ?.filter(
      assignment => assignment.status.name === 'Active' || assignment.status.name === 'Suspended'
    )
    ?.sort(
      (a, b) => new Date(a.lastModifiedDate).getTime() - new Date(b.lastModifiedDate).getTime()
    )[0]
  if (onlyActive) {
    return active
  }
  return (
    active ||
    assignments
      ?.filter(assignment => assignment.status.name !== 'Active')
      ?.sort(
        (a, b) => new Date(b.lastModifiedDate).getTime() - new Date(a.lastModifiedDate).getTime()
      )[0]
  )
}

export const columns = [
  { field: 'globalId', title: 'GlobalID', align: 'left', width: '100px' },
  { field: 'marca', title: 'Marca', align: 'left', width: '100px', disableSorting: true },
  { field: 'personName', title: 'Name', align: 'left', disableSorting: true },
  { field: 'managerName', title: 'Manager', align: 'left', collapsible: true },
  {
    field: 'email',
    title: 'Email',
    align: 'left',
    collapsible: true,
    render: rowData => (rowData.email && rowData.email !== 'null' ? rowData.email : '')
  },
  {
    field: 'type',
    title: 'Type',
    align: 'left',
    collapsible: true,
    width: '100px',
    disableSorting: true
  },
  {
    field: 'status',
    title: 'Status',
    align: 'left',
    collapsible: true,
    width: '100px',
    disableSorting: true,
    render: rowData => (rowData.status ? 'Enabled' : 'Disabled')
  },
  {
    field: 'assignmentStatus',
    title: 'Assignment',
    align: 'left',
    width: '100px',
    collapsible: true,
    disableSorting: true
  }
]

export const partnersWithAssignmentValidationSchema = Yup.object().shape({
  externalPartnerType: Yup.number().required('External Partner Type is required'),
  firstName: Yup.string().required('First name is required'),
  lastName: Yup.string().required('Last name is required'),
  email: Yup.string().email('Invalid email format'),
  phone: Yup.string().matches(phoneRegExp, 'Phone number is invalid').required('Phone is required')
})

export const partnersValidationSchema = Yup.object().shape({
  firstName: Yup.string().required('First name is required'),
  lastName: Yup.string().required('Last name is required'),
  email: Yup.string()
    .email('Invalid email')
    .when('emailNotProvided', ([emailNotProvided], schema) =>
      emailNotProvided ? schema.nullable() : schema.required('Email is required')
    ),
  phone: Yup.string().when('phoneNotProvided', ([phoneNotProvided], schema) =>
    phoneNotProvided
      ? schema.nullable()
      : schema.matches(phoneRegExp, 'Phone number is invalid').required('Phone is required')
  ),
  isEnabled: Yup.boolean().required('Status is required'),
  details: Yup.string().nullable()
})

export const getFilters = (
  typeOptions: AutocompleteOption[],
  managersOptions: AutocompleteOption[],
  assignmentStatusOptions: AutocompleteOption[]
) => {
  return [
    {
      name: 'isEnabled',
      value: '',
      filter: <Autocomplete variant="outlined" label="Status" options={statusOptions || []} />,
      type: 'autocomplete',
      label: 'Status'
    },
    {
      name: 'externalPartnerTypeId',
      value: '',
      filter: (
        <Autocomplete
          variant="outlined"
          label="External Partner Type"
          options={typeOptions || []}
        />
      ),
      type: 'autocomplete',
      label: 'External Partner Type'
    },
    {
      name: 'managerId',
      value: '',
      filter: <Autocomplete variant="outlined" label="Manager" options={managersOptions || []} />,
      type: 'autocomplete',
      label: 'Manager'
    },
    {
      name: 'status',
      value: '',
      filter: (
        <Autocomplete variant="outlined" label="Status" options={assignmentStatusOptions || []} />
      ),
      type: 'autocomplete',
      label: 'Assignment status'
    }
  ]
}
